/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { Col, Table } from "reactstrap";
import "../../../components/Globals.css";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ImageCarousels from "../../../components/DisplayImageCarsouels";
import { useSelector } from "react-redux";
import { CircleSpinnerOverlay } from "react-spinner-overlay";

export const ImageDownloadTable = ({ storeIecFormData }: any) => {
  const [showDialog, setShowDialog] = useState(false);
  const [state, setState] = useState({
    show: "",
    storeImage: "",
    indexValue: 0,
    base64Value: "",
    getImage: false,
    imagePath: "",
  });

  /** Method to open Single image Dialog */
  const handleClickOpen = (
    view: string,
    image: any,
    indexvalue: any,
    imagePath: any
  ) => {
    setState({
      ...state,
      show: view,
      storeImage: image,
      indexValue: indexvalue ?? 0,
      imagePath: imagePath,
    });
    setShowDialog(!showDialog);
  };

  /** Method to close Dialog */
  const handleCloseDialog = () => {
    setShowDialog(!showDialog);
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const { storeImageData, isLoading } = useSelector(
    (state: any) => state.iecActivity
  );

  /** Method to open all images Dialog */
  const handleViewAll = (view: string) => {
    setState({ ...state, show: view });
    setShowDialog(!showDialog);
  };

  /** Method to download single image */
  const handleDownload = (base64String: any, imagePath?: any) => {
    setState({ ...state, base64Value: base64String, imagePath: imagePath });
    let a = document.createElement("a");
    a.href = `data:image/jpeg;base64,${base64String}`;
    a.download = `${imagePath}`;
    a.click();
    setState({ ...state, getImage: false });
  };

  /** Method to download all images */
  const handleDownloadAll = () => {
    storeImageData.data.forEach((item: any, index: number) => {
      setTimeout(() => {
        // Pass both the base64 string and the imagePath to the handleDownload function
        handleDownload(item.base64, item.imagePath);
      }, index * 2000); // Delay to avoid overloading the browser with simultaneous downloads
    });
  };
  

  /** Method to download single image in image popup */
  const handleDownloadSingleImage = async () => {
    setState({ ...state, getImage: true });
  };

  useEffect(() => {
    if (state.getImage) {
      handleDownload(state.storeImage, state.imagePath);
    }
  }, [state]);

  return (
    <div className="iec-form-details-container mt-3">
      {/* Section Header with View All / Download All buttons */}
      <div className="documents-section-header">
        <div className="section-title">
          <h3 className="section-header-text">Documents</h3>
          <span className="document-count">
            ({storeImageData.data && storeImageData.data.length} files)
          </span>
        </div>
        <div className="section-actions">
          <button 
            className="action-button view-all-btn"
            onClick={() => handleViewAll("all")}
          >
            View All
          </button>
          <button 
            className="action-button download-all-btn"
            onClick={handleDownloadAll}
          >
            Download All
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="documents-table-container">
        {!isLoading && (
          <Table className="documents-table">
            <thead>
              <tr>
                <th className="table-header filename-header">
                  Filename
                </th>
                <th className="table-header action-header">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {storeImageData.data?.map((value: any, index: number) => {
                return (
                  <tr key={index} className="table-row">
                    <td className="filename-cell">{value.imagePath}</td>
                    <td className="actions-cell">
                      <div className="action-buttons">
                        <button
                          className="table-action-btn view-btn"
                          onClick={() =>
                            handleClickOpen(
                              "single",
                              value.base64,
                              index,
                              value.imagePath
                            )
                          }
                        >
                          View
                        </button>
                        <button
                          className="table-action-btn download-btn"
                          onClick={() =>
                            handleDownload(value.base64, value.imagePath)
                          }
                        >
                          Download
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
        {isLoading && (
          <div className="loading-container">
            <CircleSpinnerOverlay
              loading={isLoading}
              overlayColor="rgba(147, 166, 199, 0.1)"
              color="#5C79AA"
            />
          </div>
        )}
      </div>

      {/* User Information Section */}
      <div className="user-info-section">
        <div className="user-info-grid">
          <div className="info-item">
            <label className="info-label">Submitted By</label>
            <span className="info-value">
              {storeIecFormData &&
                storeIecFormData.data &&
                storeIecFormData.data.length > 0 &&
                storeIecFormData.data[0].submittedBy}
            </span>
          </div>
          <div className="info-item">
            <label className="info-label">Mobile Number</label>
            <span className="info-value">
              {storeIecFormData &&
                storeIecFormData.data &&
                storeIecFormData.data.length > 0 &&
                storeIecFormData.data[0].mobileNumber}
            </span>
          </div>
          <div className="info-item">
            <label className="info-label">Designation</label>
            <span className="info-value">
              {storeIecFormData &&
                storeIecFormData.data &&
                storeIecFormData.data.length > 0 &&
                storeIecFormData.data[0].role}
            </span>
          </div>
        </div>
      </div>

      {/* Dialog for Image Viewing */}
      {showDialog && (
        <Dialog
          PaperProps={{
            style: {
              backgroundColor: "transparent",
              boxShadow: "none",
              display: "flex",
              justifyContent: "center",
              width: "36%",
            },
          }}
          fullScreen={fullScreen}
          open={showDialog}
          onClose={handleCloseDialog}
          aria-labelledby="responsive-dialog-title"
        >
          <div className="downloadButtonDev">
            {state.show === "single" ? (
              <button
                className="downloadButton"
                onClick={handleDownloadSingleImage}
              >
                Download
              </button>
            ) : (
              <button className="downloadButton" onClick={handleDownloadAll}>
                Download All
              </button>
            )}
          </div>
          <DialogContent className="dialogContent">
            <div>
              {state.show === "single" ? (
                <div className="dialogContentText">
                  <img
                    style={{
                      maxWidth: "60%",
                      height: "auto",
                      objectFit: "cover",
                    }}
                    src={"data:image/jpeg;base64," + state.storeImage}
                    alt="Base64 Single"
                  />
                </div>
              ) : (
                <div className="dialogContentText">
                  <ImageCarousels />
                </div>
              )}
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};
